import { useState, useRef, useEffect } from 'react';

export const useTimer = () => {
  const [totalTime, setTotalTime] = useState<number>(0);
  const [timeRemaining, setTimeRemaining] = useState<number | null>(null);
  const timerInterval = useRef<NodeJS.Timeout>();

  const startTimer = (seconds: number) => {
    console.log('Starting timer with seconds:', seconds);
    setTotalTime(seconds);
    setTimeRemaining(seconds);

    if (timerInterval.current) {
      clearInterval(timerInterval.current);
    }

    timerInterval.current = setInterval(() => {
      setTimeRemaining((prev) => {
        if (prev === null || prev <= 0) {
          clearInterval(timerInterval.current);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };

  const stopTimer = () => {
    if (timerInterval.current) {
      clearInterval(timerInterval.current);
      timerInterval.current = undefined;
    }
  };

  useEffect(() => {
    return () => {
      stopTimer();
    };
  }, []);

  return {
    totalTime,
    timeRemaining,
    startTimer,
    stopTimer
  };
};
